// src/components/Navbar.js
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSidebar } from '../../contexts/SidebarContext';


const Navbar = () => {
    const history = useNavigate();
    const token = localStorage.getItem('token');
    
    // This will now throw a proper error if used outside provider
    const { toggleSidebar } = useSidebar();

    const logout = () => {
        localStorage.removeItem("token");
        localStorage.clear();
        history('/');
    }

    return (
        <header id="headers" className="headers fixed-top d-flex align-items-center">
            <div className="d-flex align-items-center justify-content-between">
                <Link to="/manage/dashbaord/users/" className="logo d-flex align-items-center">
                    {/* <span className="d-none d-lg-block">organizer</span> */}
                </Link>
                <button 
                    className="btn btn-link toggle-sidebar-btn p-0 me-2"
                    onClick={toggleSidebar}
                    aria-label="Toggle sidebar"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: "80px", fontSize: '1.5rem', width: "30px", height: "30px" }} fill="currentColor" className="bi bi-list" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
                    </svg>
                </button>
            </div>
            
            <nav className="headers-nav ms-auto">
                <ul className="d-flex align-items-center">
                    <li className="nav-item dropdown pe-3">
                        <Link className="nav-link nav-profile d-flex align-items-center pe-0" to="#" data-bs-toggle="dropdown">
                            <span className="d-none d-md-block"><b>Admin</b></span>
                        </Link>
                        
                        <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                            <li className="dropdown-headers">
                                <h6>Admin</h6>
                            </li>
                            <li><hr className="dropdown-divider" /></li>
                            <li>
                                <Link className="dropdown-item d-flex align-items-center" to="/">
                                    <i className="bi bi-grid"></i>
                                    <span>Homepage</span>
                                </Link>
                            </li>
                          
                            <li><hr className="dropdown-divider" /></li>
                            
                            <li>
                                <button className="dropdown-item d-flex align-items-center" onClick={logout}>
                                    <i className="bi bi-box-arrow-right"></i>
                                    <span>Sign Out</span>
                                </button>
                            </li>
                        </ul>
                    </li>
                </ul>
            </nav>
        </header>
    )
}

export default Navbar;